import { render, staticRenderFns } from "./require_invoice_confirmation.vue?vue&type=template&id=22f2a9be&"
import script from "./require_invoice_confirmation.vue?vue&type=script&lang=js&"
export * from "./require_invoice_confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports